import Log from 'cgil-log';

export const APP = 'sentinelle';
export const VERSION = '1.3.0';
export const BUILD_DATE = '25-02-2024';
export const DEV = process.env.NODE_ENV === 'development';
export const HOME = DEV ? 'http://localhost:8080/?x=538224.21&y=152378.17&zoom=8' : '/';
// export const DEFAULT_BASE_SERVER_URL = DEV ? `http://my${APP}.lausanne.ch:8000` : '';
export const DEFAULT_BASE_SERVER_URL = DEV ? 'http://localhost:8989' : '';
export const getLog = (ModuleName, verbosityDev, verbosityProd) => (
  (DEV) ? new Log(ModuleName, verbosityDev) : new Log(ModuleName, verbosityProd)
);
export const BASE_PATH = DEV ? '' : '';
